import './IndicatorImpact.css';

import React from "react";
import useIndicatorImpact from '../../hooks/useIndicatorImpact';
import { Avatar, Box } from '@mui/material';
import { fullImagePath, generateClassName } from '../../../b2b-common/helpers';

const IndicatorImpact = ({ frameworkSuite, frameworkId, indicator, className = null, iconsCount = 4, iconsSize = 25 }) => {
    const { indicatorImpact } = useIndicatorImpact(frameworkSuite, frameworkId, indicator.indicatorUUID, 'bullet');
    if (!indicatorImpact || indicatorImpact.length == 0) return null;
    // console.log('IndicatorImpact', indicatorImpact);

    return (
        <Box className={generateClassName('indicator-impact', '', className)}>
            {indicatorImpact.map((item, index) => {
                const bulletImage = fullImagePath(item.imagePath);
                return (
                    <Avatar
                        variant='square'
                        key={index}
                        src={bulletImage}
                        alt={`Impact ${index}`}
                        sx={{ width: iconsSize, height: iconsSize }}
                    />
                );
            })}
        </Box>
    );
}

export default IndicatorImpact;